/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
enum WidgetType {
  Bus = 'ContentfulWidgetBus',
  ContentBlock= 'ContentfulWidgetContentBlock',
  HeroSlider = 'ContentfulWidgetHeroSlider',
  MediaCollectionBuilder = 'ContentfulWidgetMediaCollectionBuilder',
  Schedule = 'ContentfulWidgetSchedule',
  Search= 'ContentfulWidgetSearch',
}

export { WidgetType };

enum WidgetContentBlockContentType {
  GetAlerts = 'Get Alerts CHDTV',
}

export { WidgetContentBlockContentType };
